import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { LoadingSpinner } from '@/shared/components/ui/LoadingSpinner';
import { ROUTES } from '@/shared/config/routes.config';

interface AdminProtectedRouteProps {
  children: ReactNode;
  fallbackPath?: string;
}

export const AdminProtectedRoute = ({ 
  children, 
  fallbackPath = ROUTES.DASHBOARD 
}: AdminProtectedRouteProps) => {
  const { isAuthenticated, isLoading, user } = useAuth();

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" label="Checking admin access..." />
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to={ROUTES.AUTH.LOGIN} replace />;
  }

  // Check if user has admin access
  const isAdmin = user?.role === 'admin' || user?.permissions?.includes('admin:read');
  if (!isAdmin) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
};